/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AddOrUpdateEmailRequest,
  CreateExternalApiUserRequest,
  CreateExternalApiUserResponse,
  CreateUser,
  CreateUserResponse,
  CreateUserResult,
  GetSimpleUserParams,
  GetSimpleUsersByIdsParams,
  SimpleLicense,
  SimpleUser,
  SimpleUserWithPerson,
  SimpleUserWithPersonAndEmailInfo,
  SimpleUserWithPersonAndEmailInfoPagination,
  UpdateApiKeyRequest,
  UpdateApiKeyResponse,
  UpdateGroupMembershipsRequest,
  UpdateUser,
  UserDto,
  UserDtoPaginatedData,
  UserGetCreateUsersParams,
  UserGetPaginatedSimpleUsersWithPersonAndEmailInfoParams,
  UserGetPaginatedUserDataParams,
  UserGetSimpleUsersWithNamesParams,
  UserGetSimpleUsersWithPersonAndEmailInfoParams,
  UserGetUserGroupsParams,
  UserGetUserLicensesParams,
  UserGetUserParams
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getUserGetCreateUsersUrl = (params?: UserGetCreateUsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["personIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/User/GetCreateUsers?${stringifiedParams}` : `/api/User/GetCreateUsers`
}

export const userGetCreateUsers = async (params?: UserGetCreateUsersParams, options?: RequestInit): Promise<CreateUser[]> => {
  
  return customInstance<CreateUser[]>(getUserGetCreateUsersUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getUserGetCreateUsersQueryKey = (params?: UserGetCreateUsersParams,) => {
    return [
    `/api/User/GetCreateUsers`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getUserGetCreateUsersQueryOptions = <TData = Awaited<ReturnType<typeof userGetCreateUsers>>, TError = ErrorType<unknown>>(params?: UserGetCreateUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetCreateUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetCreateUsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetCreateUsers>>> = ({ signal }) => userGetCreateUsers(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userGetCreateUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserGetCreateUsersQueryResult = NonNullable<Awaited<ReturnType<typeof userGetCreateUsers>>>
export type UserGetCreateUsersQueryError = ErrorType<unknown>


export function useUserGetCreateUsers<TData = Awaited<ReturnType<typeof userGetCreateUsers>>, TError = ErrorType<unknown>>(
 params: undefined |  UserGetCreateUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetCreateUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetCreateUsers>>,
          TError,
          Awaited<ReturnType<typeof userGetCreateUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetCreateUsers<TData = Awaited<ReturnType<typeof userGetCreateUsers>>, TError = ErrorType<unknown>>(
 params?: UserGetCreateUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetCreateUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetCreateUsers>>,
          TError,
          Awaited<ReturnType<typeof userGetCreateUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetCreateUsers<TData = Awaited<ReturnType<typeof userGetCreateUsers>>, TError = ErrorType<unknown>>(
 params?: UserGetCreateUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetCreateUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useUserGetCreateUsers<TData = Awaited<ReturnType<typeof userGetCreateUsers>>, TError = ErrorType<unknown>>(
 params?: UserGetCreateUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetCreateUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserGetCreateUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getUserGetCreateUsersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof userGetCreateUsers>>, TError = ErrorType<unknown>>(params?: UserGetCreateUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetCreateUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetCreateUsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetCreateUsers>>> = ({ signal }) => userGetCreateUsers(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetCreateUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserGetCreateUsersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof userGetCreateUsers>>>
export type UserGetCreateUsersSuspenseQueryError = ErrorType<unknown>


export function useUserGetCreateUsersSuspense<TData = Awaited<ReturnType<typeof userGetCreateUsers>>, TError = ErrorType<unknown>>(
 params: undefined |  UserGetCreateUsersParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetCreateUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetCreateUsersSuspense<TData = Awaited<ReturnType<typeof userGetCreateUsers>>, TError = ErrorType<unknown>>(
 params?: UserGetCreateUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetCreateUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetCreateUsersSuspense<TData = Awaited<ReturnType<typeof userGetCreateUsers>>, TError = ErrorType<unknown>>(
 params?: UserGetCreateUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetCreateUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useUserGetCreateUsersSuspense<TData = Awaited<ReturnType<typeof userGetCreateUsers>>, TError = ErrorType<unknown>>(
 params?: UserGetCreateUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetCreateUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserGetCreateUsersSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getUserCreateUrl = () => {


  

  return `/api/User/Create`
}

export const userCreate = async (createUser: CreateUser, options?: RequestInit): Promise<CreateUserResponse> => {
  
  return customInstance<CreateUserResponse>(getUserCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createUser,)
  }
);}




export const getUserCreateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userCreate>>, TError,{data: BodyType<CreateUser>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userCreate>>, TError,{data: BodyType<CreateUser>}, TContext> => {

const mutationKey = ['userCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userCreate>>, {data: BodyType<CreateUser>}> = (props) => {
          const {data} = props ?? {};

          return  userCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserCreateMutationResult = NonNullable<Awaited<ReturnType<typeof userCreate>>>
    export type UserCreateMutationBody = BodyType<CreateUser>
    export type UserCreateMutationError = ErrorType<unknown>

    export const useUserCreate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userCreate>>, TError,{data: BodyType<CreateUser>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userCreate>>,
        TError,
        {data: BodyType<CreateUser>},
        TContext
      > => {

      const mutationOptions = getUserCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getUserCreateUsersUrl = () => {


  

  return `/api/User/CreateUsers`
}

export const userCreateUsers = async (createUser: CreateUser[], options?: RequestInit): Promise<CreateUserResult[]> => {
  
  return customInstance<CreateUserResult[]>(getUserCreateUsersUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createUser,)
  }
);}




export const getUserCreateUsersMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userCreateUsers>>, TError,{data: BodyType<CreateUser[]>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userCreateUsers>>, TError,{data: BodyType<CreateUser[]>}, TContext> => {

const mutationKey = ['userCreateUsers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userCreateUsers>>, {data: BodyType<CreateUser[]>}> = (props) => {
          const {data} = props ?? {};

          return  userCreateUsers(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserCreateUsersMutationResult = NonNullable<Awaited<ReturnType<typeof userCreateUsers>>>
    export type UserCreateUsersMutationBody = BodyType<CreateUser[]>
    export type UserCreateUsersMutationError = ErrorType<unknown>

    export const useUserCreateUsers = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userCreateUsers>>, TError,{data: BodyType<CreateUser[]>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userCreateUsers>>,
        TError,
        {data: BodyType<CreateUser[]>},
        TContext
      > => {

      const mutationOptions = getUserCreateUsersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getUserUpdateGroupMembershipsUrl = () => {


  

  return `/api/User/UpdateGroupMemberships`
}

export const userUpdateGroupMemberships = async (updateGroupMembershipsRequest: UpdateGroupMembershipsRequest, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getUserUpdateGroupMembershipsUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateGroupMembershipsRequest,)
  }
);}




export const getUserUpdateGroupMembershipsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userUpdateGroupMemberships>>, TError,{data: BodyType<UpdateGroupMembershipsRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userUpdateGroupMemberships>>, TError,{data: BodyType<UpdateGroupMembershipsRequest>}, TContext> => {

const mutationKey = ['userUpdateGroupMemberships'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userUpdateGroupMemberships>>, {data: BodyType<UpdateGroupMembershipsRequest>}> = (props) => {
          const {data} = props ?? {};

          return  userUpdateGroupMemberships(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserUpdateGroupMembershipsMutationResult = NonNullable<Awaited<ReturnType<typeof userUpdateGroupMemberships>>>
    export type UserUpdateGroupMembershipsMutationBody = BodyType<UpdateGroupMembershipsRequest>
    export type UserUpdateGroupMembershipsMutationError = ErrorType<unknown>

    export const useUserUpdateGroupMemberships = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userUpdateGroupMemberships>>, TError,{data: BodyType<UpdateGroupMembershipsRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userUpdateGroupMemberships>>,
        TError,
        {data: BodyType<UpdateGroupMembershipsRequest>},
        TContext
      > => {

      const mutationOptions = getUserUpdateGroupMembershipsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getUserGetPaginatedUserDataUrl = (params?: UserGetPaginatedUserDataParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["includeUserIds","excludeUserIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/User/GetPaginatedUserData?${stringifiedParams}` : `/api/User/GetPaginatedUserData`
}

export const userGetPaginatedUserData = async (params?: UserGetPaginatedUserDataParams, options?: RequestInit): Promise<UserDtoPaginatedData> => {
  
  return customInstance<UserDtoPaginatedData>(getUserGetPaginatedUserDataUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getUserGetPaginatedUserDataQueryKey = (params?: UserGetPaginatedUserDataParams,) => {
    return [
    `/api/User/GetPaginatedUserData`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getUserGetPaginatedUserDataQueryOptions = <TData = Awaited<ReturnType<typeof userGetPaginatedUserData>>, TError = ErrorType<unknown>>(params?: UserGetPaginatedUserDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetPaginatedUserData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetPaginatedUserDataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetPaginatedUserData>>> = ({ signal }) => userGetPaginatedUserData(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userGetPaginatedUserData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserGetPaginatedUserDataQueryResult = NonNullable<Awaited<ReturnType<typeof userGetPaginatedUserData>>>
export type UserGetPaginatedUserDataQueryError = ErrorType<unknown>


export function useUserGetPaginatedUserData<TData = Awaited<ReturnType<typeof userGetPaginatedUserData>>, TError = ErrorType<unknown>>(
 params: undefined |  UserGetPaginatedUserDataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetPaginatedUserData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetPaginatedUserData>>,
          TError,
          Awaited<ReturnType<typeof userGetPaginatedUserData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetPaginatedUserData<TData = Awaited<ReturnType<typeof userGetPaginatedUserData>>, TError = ErrorType<unknown>>(
 params?: UserGetPaginatedUserDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetPaginatedUserData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetPaginatedUserData>>,
          TError,
          Awaited<ReturnType<typeof userGetPaginatedUserData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetPaginatedUserData<TData = Awaited<ReturnType<typeof userGetPaginatedUserData>>, TError = ErrorType<unknown>>(
 params?: UserGetPaginatedUserDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetPaginatedUserData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useUserGetPaginatedUserData<TData = Awaited<ReturnType<typeof userGetPaginatedUserData>>, TError = ErrorType<unknown>>(
 params?: UserGetPaginatedUserDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetPaginatedUserData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserGetPaginatedUserDataQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getUserGetPaginatedUserDataSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof userGetPaginatedUserData>>, TError = ErrorType<unknown>>(params?: UserGetPaginatedUserDataParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetPaginatedUserData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetPaginatedUserDataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetPaginatedUserData>>> = ({ signal }) => userGetPaginatedUserData(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetPaginatedUserData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserGetPaginatedUserDataSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof userGetPaginatedUserData>>>
export type UserGetPaginatedUserDataSuspenseQueryError = ErrorType<unknown>


export function useUserGetPaginatedUserDataSuspense<TData = Awaited<ReturnType<typeof userGetPaginatedUserData>>, TError = ErrorType<unknown>>(
 params: undefined |  UserGetPaginatedUserDataParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetPaginatedUserData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetPaginatedUserDataSuspense<TData = Awaited<ReturnType<typeof userGetPaginatedUserData>>, TError = ErrorType<unknown>>(
 params?: UserGetPaginatedUserDataParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetPaginatedUserData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetPaginatedUserDataSuspense<TData = Awaited<ReturnType<typeof userGetPaginatedUserData>>, TError = ErrorType<unknown>>(
 params?: UserGetPaginatedUserDataParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetPaginatedUserData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useUserGetPaginatedUserDataSuspense<TData = Awaited<ReturnType<typeof userGetPaginatedUserData>>, TError = ErrorType<unknown>>(
 params?: UserGetPaginatedUserDataParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetPaginatedUserData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserGetPaginatedUserDataSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getUserGetUserUrl = (params?: UserGetUserParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/User/GetUser?${stringifiedParams}` : `/api/User/GetUser`
}

export const userGetUser = async (params?: UserGetUserParams, options?: RequestInit): Promise<UserDto> => {
  
  return customInstance<UserDto>(getUserGetUserUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getUserGetUserQueryKey = (params?: UserGetUserParams,) => {
    return [
    `/api/User/GetUser`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getUserGetUserQueryOptions = <TData = Awaited<ReturnType<typeof userGetUser>>, TError = ErrorType<unknown>>(params?: UserGetUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetUserQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetUser>>> = ({ signal }) => userGetUser(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userGetUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserGetUserQueryResult = NonNullable<Awaited<ReturnType<typeof userGetUser>>>
export type UserGetUserQueryError = ErrorType<unknown>


export function useUserGetUser<TData = Awaited<ReturnType<typeof userGetUser>>, TError = ErrorType<unknown>>(
 params: undefined |  UserGetUserParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetUser>>,
          TError,
          Awaited<ReturnType<typeof userGetUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetUser<TData = Awaited<ReturnType<typeof userGetUser>>, TError = ErrorType<unknown>>(
 params?: UserGetUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetUser>>,
          TError,
          Awaited<ReturnType<typeof userGetUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetUser<TData = Awaited<ReturnType<typeof userGetUser>>, TError = ErrorType<unknown>>(
 params?: UserGetUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useUserGetUser<TData = Awaited<ReturnType<typeof userGetUser>>, TError = ErrorType<unknown>>(
 params?: UserGetUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserGetUserQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getUserGetUserSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof userGetUser>>, TError = ErrorType<unknown>>(params?: UserGetUserParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetUserQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetUser>>> = ({ signal }) => userGetUser(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserGetUserSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof userGetUser>>>
export type UserGetUserSuspenseQueryError = ErrorType<unknown>


export function useUserGetUserSuspense<TData = Awaited<ReturnType<typeof userGetUser>>, TError = ErrorType<unknown>>(
 params: undefined |  UserGetUserParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetUserSuspense<TData = Awaited<ReturnType<typeof userGetUser>>, TError = ErrorType<unknown>>(
 params?: UserGetUserParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetUserSuspense<TData = Awaited<ReturnType<typeof userGetUser>>, TError = ErrorType<unknown>>(
 params?: UserGetUserParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useUserGetUserSuspense<TData = Awaited<ReturnType<typeof userGetUser>>, TError = ErrorType<unknown>>(
 params?: UserGetUserParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserGetUserSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getUserGetSimpleUsersWithPersonAndEmailInfoUrl = (params?: UserGetSimpleUsersWithPersonAndEmailInfoParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["includeUserIds","excludeUserIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/User/GetSimpleUsersWithPersonAndEmailInfo?${stringifiedParams}` : `/api/User/GetSimpleUsersWithPersonAndEmailInfo`
}

export const userGetSimpleUsersWithPersonAndEmailInfo = async (params?: UserGetSimpleUsersWithPersonAndEmailInfoParams, options?: RequestInit): Promise<SimpleUserWithPersonAndEmailInfo[]> => {
  
  return customInstance<SimpleUserWithPersonAndEmailInfo[]>(getUserGetSimpleUsersWithPersonAndEmailInfoUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getUserGetSimpleUsersWithPersonAndEmailInfoQueryKey = (params?: UserGetSimpleUsersWithPersonAndEmailInfoParams,) => {
    return [
    `/api/User/GetSimpleUsersWithPersonAndEmailInfo`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getUserGetSimpleUsersWithPersonAndEmailInfoQueryOptions = <TData = Awaited<ReturnType<typeof userGetSimpleUsersWithPersonAndEmailInfo>>, TError = ErrorType<unknown>>(params?: UserGetSimpleUsersWithPersonAndEmailInfoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetSimpleUsersWithPersonAndEmailInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetSimpleUsersWithPersonAndEmailInfoQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetSimpleUsersWithPersonAndEmailInfo>>> = ({ signal }) => userGetSimpleUsersWithPersonAndEmailInfo(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userGetSimpleUsersWithPersonAndEmailInfo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserGetSimpleUsersWithPersonAndEmailInfoQueryResult = NonNullable<Awaited<ReturnType<typeof userGetSimpleUsersWithPersonAndEmailInfo>>>
export type UserGetSimpleUsersWithPersonAndEmailInfoQueryError = ErrorType<unknown>


export function useUserGetSimpleUsersWithPersonAndEmailInfo<TData = Awaited<ReturnType<typeof userGetSimpleUsersWithPersonAndEmailInfo>>, TError = ErrorType<unknown>>(
 params: undefined |  UserGetSimpleUsersWithPersonAndEmailInfoParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetSimpleUsersWithPersonAndEmailInfo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetSimpleUsersWithPersonAndEmailInfo>>,
          TError,
          Awaited<ReturnType<typeof userGetSimpleUsersWithPersonAndEmailInfo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetSimpleUsersWithPersonAndEmailInfo<TData = Awaited<ReturnType<typeof userGetSimpleUsersWithPersonAndEmailInfo>>, TError = ErrorType<unknown>>(
 params?: UserGetSimpleUsersWithPersonAndEmailInfoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetSimpleUsersWithPersonAndEmailInfo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetSimpleUsersWithPersonAndEmailInfo>>,
          TError,
          Awaited<ReturnType<typeof userGetSimpleUsersWithPersonAndEmailInfo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetSimpleUsersWithPersonAndEmailInfo<TData = Awaited<ReturnType<typeof userGetSimpleUsersWithPersonAndEmailInfo>>, TError = ErrorType<unknown>>(
 params?: UserGetSimpleUsersWithPersonAndEmailInfoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetSimpleUsersWithPersonAndEmailInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useUserGetSimpleUsersWithPersonAndEmailInfo<TData = Awaited<ReturnType<typeof userGetSimpleUsersWithPersonAndEmailInfo>>, TError = ErrorType<unknown>>(
 params?: UserGetSimpleUsersWithPersonAndEmailInfoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetSimpleUsersWithPersonAndEmailInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserGetSimpleUsersWithPersonAndEmailInfoQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getUserGetSimpleUsersWithPersonAndEmailInfoSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof userGetSimpleUsersWithPersonAndEmailInfo>>, TError = ErrorType<unknown>>(params?: UserGetSimpleUsersWithPersonAndEmailInfoParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetSimpleUsersWithPersonAndEmailInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetSimpleUsersWithPersonAndEmailInfoQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetSimpleUsersWithPersonAndEmailInfo>>> = ({ signal }) => userGetSimpleUsersWithPersonAndEmailInfo(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetSimpleUsersWithPersonAndEmailInfo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserGetSimpleUsersWithPersonAndEmailInfoSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof userGetSimpleUsersWithPersonAndEmailInfo>>>
export type UserGetSimpleUsersWithPersonAndEmailInfoSuspenseQueryError = ErrorType<unknown>


export function useUserGetSimpleUsersWithPersonAndEmailInfoSuspense<TData = Awaited<ReturnType<typeof userGetSimpleUsersWithPersonAndEmailInfo>>, TError = ErrorType<unknown>>(
 params: undefined |  UserGetSimpleUsersWithPersonAndEmailInfoParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetSimpleUsersWithPersonAndEmailInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetSimpleUsersWithPersonAndEmailInfoSuspense<TData = Awaited<ReturnType<typeof userGetSimpleUsersWithPersonAndEmailInfo>>, TError = ErrorType<unknown>>(
 params?: UserGetSimpleUsersWithPersonAndEmailInfoParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetSimpleUsersWithPersonAndEmailInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetSimpleUsersWithPersonAndEmailInfoSuspense<TData = Awaited<ReturnType<typeof userGetSimpleUsersWithPersonAndEmailInfo>>, TError = ErrorType<unknown>>(
 params?: UserGetSimpleUsersWithPersonAndEmailInfoParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetSimpleUsersWithPersonAndEmailInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useUserGetSimpleUsersWithPersonAndEmailInfoSuspense<TData = Awaited<ReturnType<typeof userGetSimpleUsersWithPersonAndEmailInfo>>, TError = ErrorType<unknown>>(
 params?: UserGetSimpleUsersWithPersonAndEmailInfoParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetSimpleUsersWithPersonAndEmailInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserGetSimpleUsersWithPersonAndEmailInfoSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getUserGetPaginatedSimpleUsersWithPersonAndEmailInfoUrl = (params?: UserGetPaginatedSimpleUsersWithPersonAndEmailInfoParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["excludeUserIds","includeUserIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/User/GetPaginatedSimpleUsersWithPersonAndEmailInfo?${stringifiedParams}` : `/api/User/GetPaginatedSimpleUsersWithPersonAndEmailInfo`
}

export const userGetPaginatedSimpleUsersWithPersonAndEmailInfo = async (params?: UserGetPaginatedSimpleUsersWithPersonAndEmailInfoParams, options?: RequestInit): Promise<SimpleUserWithPersonAndEmailInfoPagination> => {
  
  return customInstance<SimpleUserWithPersonAndEmailInfoPagination>(getUserGetPaginatedSimpleUsersWithPersonAndEmailInfoUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getUserGetPaginatedSimpleUsersWithPersonAndEmailInfoQueryKey = (params?: UserGetPaginatedSimpleUsersWithPersonAndEmailInfoParams,) => {
    return [
    `/api/User/GetPaginatedSimpleUsersWithPersonAndEmailInfo`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getUserGetPaginatedSimpleUsersWithPersonAndEmailInfoQueryOptions = <TData = Awaited<ReturnType<typeof userGetPaginatedSimpleUsersWithPersonAndEmailInfo>>, TError = ErrorType<unknown>>(params?: UserGetPaginatedSimpleUsersWithPersonAndEmailInfoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetPaginatedSimpleUsersWithPersonAndEmailInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetPaginatedSimpleUsersWithPersonAndEmailInfoQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetPaginatedSimpleUsersWithPersonAndEmailInfo>>> = ({ signal }) => userGetPaginatedSimpleUsersWithPersonAndEmailInfo(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userGetPaginatedSimpleUsersWithPersonAndEmailInfo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserGetPaginatedSimpleUsersWithPersonAndEmailInfoQueryResult = NonNullable<Awaited<ReturnType<typeof userGetPaginatedSimpleUsersWithPersonAndEmailInfo>>>
export type UserGetPaginatedSimpleUsersWithPersonAndEmailInfoQueryError = ErrorType<unknown>


export function useUserGetPaginatedSimpleUsersWithPersonAndEmailInfo<TData = Awaited<ReturnType<typeof userGetPaginatedSimpleUsersWithPersonAndEmailInfo>>, TError = ErrorType<unknown>>(
 params: undefined |  UserGetPaginatedSimpleUsersWithPersonAndEmailInfoParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetPaginatedSimpleUsersWithPersonAndEmailInfo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetPaginatedSimpleUsersWithPersonAndEmailInfo>>,
          TError,
          Awaited<ReturnType<typeof userGetPaginatedSimpleUsersWithPersonAndEmailInfo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetPaginatedSimpleUsersWithPersonAndEmailInfo<TData = Awaited<ReturnType<typeof userGetPaginatedSimpleUsersWithPersonAndEmailInfo>>, TError = ErrorType<unknown>>(
 params?: UserGetPaginatedSimpleUsersWithPersonAndEmailInfoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetPaginatedSimpleUsersWithPersonAndEmailInfo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetPaginatedSimpleUsersWithPersonAndEmailInfo>>,
          TError,
          Awaited<ReturnType<typeof userGetPaginatedSimpleUsersWithPersonAndEmailInfo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetPaginatedSimpleUsersWithPersonAndEmailInfo<TData = Awaited<ReturnType<typeof userGetPaginatedSimpleUsersWithPersonAndEmailInfo>>, TError = ErrorType<unknown>>(
 params?: UserGetPaginatedSimpleUsersWithPersonAndEmailInfoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetPaginatedSimpleUsersWithPersonAndEmailInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useUserGetPaginatedSimpleUsersWithPersonAndEmailInfo<TData = Awaited<ReturnType<typeof userGetPaginatedSimpleUsersWithPersonAndEmailInfo>>, TError = ErrorType<unknown>>(
 params?: UserGetPaginatedSimpleUsersWithPersonAndEmailInfoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetPaginatedSimpleUsersWithPersonAndEmailInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserGetPaginatedSimpleUsersWithPersonAndEmailInfoQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getUserGetPaginatedSimpleUsersWithPersonAndEmailInfoSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof userGetPaginatedSimpleUsersWithPersonAndEmailInfo>>, TError = ErrorType<unknown>>(params?: UserGetPaginatedSimpleUsersWithPersonAndEmailInfoParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetPaginatedSimpleUsersWithPersonAndEmailInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetPaginatedSimpleUsersWithPersonAndEmailInfoQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetPaginatedSimpleUsersWithPersonAndEmailInfo>>> = ({ signal }) => userGetPaginatedSimpleUsersWithPersonAndEmailInfo(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetPaginatedSimpleUsersWithPersonAndEmailInfo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserGetPaginatedSimpleUsersWithPersonAndEmailInfoSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof userGetPaginatedSimpleUsersWithPersonAndEmailInfo>>>
export type UserGetPaginatedSimpleUsersWithPersonAndEmailInfoSuspenseQueryError = ErrorType<unknown>


export function useUserGetPaginatedSimpleUsersWithPersonAndEmailInfoSuspense<TData = Awaited<ReturnType<typeof userGetPaginatedSimpleUsersWithPersonAndEmailInfo>>, TError = ErrorType<unknown>>(
 params: undefined |  UserGetPaginatedSimpleUsersWithPersonAndEmailInfoParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetPaginatedSimpleUsersWithPersonAndEmailInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetPaginatedSimpleUsersWithPersonAndEmailInfoSuspense<TData = Awaited<ReturnType<typeof userGetPaginatedSimpleUsersWithPersonAndEmailInfo>>, TError = ErrorType<unknown>>(
 params?: UserGetPaginatedSimpleUsersWithPersonAndEmailInfoParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetPaginatedSimpleUsersWithPersonAndEmailInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetPaginatedSimpleUsersWithPersonAndEmailInfoSuspense<TData = Awaited<ReturnType<typeof userGetPaginatedSimpleUsersWithPersonAndEmailInfo>>, TError = ErrorType<unknown>>(
 params?: UserGetPaginatedSimpleUsersWithPersonAndEmailInfoParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetPaginatedSimpleUsersWithPersonAndEmailInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useUserGetPaginatedSimpleUsersWithPersonAndEmailInfoSuspense<TData = Awaited<ReturnType<typeof userGetPaginatedSimpleUsersWithPersonAndEmailInfo>>, TError = ErrorType<unknown>>(
 params?: UserGetPaginatedSimpleUsersWithPersonAndEmailInfoParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetPaginatedSimpleUsersWithPersonAndEmailInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserGetPaginatedSimpleUsersWithPersonAndEmailInfoSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetSimpleUserUrl = (params?: GetSimpleUserParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/User/GetSimpleUser?${stringifiedParams}` : `/api/User/GetSimpleUser`
}

export const getSimpleUser = async (params?: GetSimpleUserParams, options?: RequestInit): Promise<SimpleUserWithPerson> => {
  
  return customInstance<SimpleUserWithPerson>(getGetSimpleUserUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetSimpleUserQueryKey = (params?: GetSimpleUserParams,) => {
    return [
    `/api/User/GetSimpleUser`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetSimpleUserQueryOptions = <TData = Awaited<ReturnType<typeof getSimpleUser>>, TError = ErrorType<unknown>>(params?: GetSimpleUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimpleUserQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimpleUser>>> = ({ signal }) => getSimpleUser(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSimpleUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSimpleUserQueryResult = NonNullable<Awaited<ReturnType<typeof getSimpleUser>>>
export type GetSimpleUserQueryError = ErrorType<unknown>


export function useGetSimpleUser<TData = Awaited<ReturnType<typeof getSimpleUser>>, TError = ErrorType<unknown>>(
 params: undefined |  GetSimpleUserParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimpleUser>>,
          TError,
          Awaited<ReturnType<typeof getSimpleUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSimpleUser<TData = Awaited<ReturnType<typeof getSimpleUser>>, TError = ErrorType<unknown>>(
 params?: GetSimpleUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimpleUser>>,
          TError,
          Awaited<ReturnType<typeof getSimpleUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSimpleUser<TData = Awaited<ReturnType<typeof getSimpleUser>>, TError = ErrorType<unknown>>(
 params?: GetSimpleUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetSimpleUser<TData = Awaited<ReturnType<typeof getSimpleUser>>, TError = ErrorType<unknown>>(
 params?: GetSimpleUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSimpleUserQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetSimpleUserSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSimpleUser>>, TError = ErrorType<unknown>>(params?: GetSimpleUserParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimpleUserQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimpleUser>>> = ({ signal }) => getSimpleUser(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSimpleUserSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSimpleUser>>>
export type GetSimpleUserSuspenseQueryError = ErrorType<unknown>


export function useGetSimpleUserSuspense<TData = Awaited<ReturnType<typeof getSimpleUser>>, TError = ErrorType<unknown>>(
 params: undefined |  GetSimpleUserParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSimpleUserSuspense<TData = Awaited<ReturnType<typeof getSimpleUser>>, TError = ErrorType<unknown>>(
 params?: GetSimpleUserParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSimpleUserSuspense<TData = Awaited<ReturnType<typeof getSimpleUser>>, TError = ErrorType<unknown>>(
 params?: GetSimpleUserParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetSimpleUserSuspense<TData = Awaited<ReturnType<typeof getSimpleUser>>, TError = ErrorType<unknown>>(
 params?: GetSimpleUserParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSimpleUserSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetSimpleUsersByIdsUrl = (params?: GetSimpleUsersByIdsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["userIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/User/GetSimpleUsersByIds?${stringifiedParams}` : `/api/User/GetSimpleUsersByIds`
}

export const getSimpleUsersByIds = async (params?: GetSimpleUsersByIdsParams, options?: RequestInit): Promise<SimpleUserWithPerson[]> => {
  
  return customInstance<SimpleUserWithPerson[]>(getGetSimpleUsersByIdsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetSimpleUsersByIdsQueryKey = (params?: GetSimpleUsersByIdsParams,) => {
    return [
    `/api/User/GetSimpleUsersByIds`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetSimpleUsersByIdsQueryOptions = <TData = Awaited<ReturnType<typeof getSimpleUsersByIds>>, TError = ErrorType<unknown>>(params?: GetSimpleUsersByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimpleUsersByIdsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimpleUsersByIds>>> = ({ signal }) => getSimpleUsersByIds(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersByIds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSimpleUsersByIdsQueryResult = NonNullable<Awaited<ReturnType<typeof getSimpleUsersByIds>>>
export type GetSimpleUsersByIdsQueryError = ErrorType<unknown>


export function useGetSimpleUsersByIds<TData = Awaited<ReturnType<typeof getSimpleUsersByIds>>, TError = ErrorType<unknown>>(
 params: undefined |  GetSimpleUsersByIdsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersByIds>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimpleUsersByIds>>,
          TError,
          Awaited<ReturnType<typeof getSimpleUsersByIds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSimpleUsersByIds<TData = Awaited<ReturnType<typeof getSimpleUsersByIds>>, TError = ErrorType<unknown>>(
 params?: GetSimpleUsersByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersByIds>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimpleUsersByIds>>,
          TError,
          Awaited<ReturnType<typeof getSimpleUsersByIds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSimpleUsersByIds<TData = Awaited<ReturnType<typeof getSimpleUsersByIds>>, TError = ErrorType<unknown>>(
 params?: GetSimpleUsersByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetSimpleUsersByIds<TData = Awaited<ReturnType<typeof getSimpleUsersByIds>>, TError = ErrorType<unknown>>(
 params?: GetSimpleUsersByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSimpleUsersByIdsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetSimpleUsersByIdsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSimpleUsersByIds>>, TError = ErrorType<unknown>>(params?: GetSimpleUsersByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimpleUsersByIdsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimpleUsersByIds>>> = ({ signal }) => getSimpleUsersByIds(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersByIds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSimpleUsersByIdsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSimpleUsersByIds>>>
export type GetSimpleUsersByIdsSuspenseQueryError = ErrorType<unknown>


export function useGetSimpleUsersByIdsSuspense<TData = Awaited<ReturnType<typeof getSimpleUsersByIds>>, TError = ErrorType<unknown>>(
 params: undefined |  GetSimpleUsersByIdsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSimpleUsersByIdsSuspense<TData = Awaited<ReturnType<typeof getSimpleUsersByIds>>, TError = ErrorType<unknown>>(
 params?: GetSimpleUsersByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSimpleUsersByIdsSuspense<TData = Awaited<ReturnType<typeof getSimpleUsersByIds>>, TError = ErrorType<unknown>>(
 params?: GetSimpleUsersByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetSimpleUsersByIdsSuspense<TData = Awaited<ReturnType<typeof getSimpleUsersByIds>>, TError = ErrorType<unknown>>(
 params?: GetSimpleUsersByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSimpleUsersByIdsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getUserGetSimpleUsersWithNamesUrl = (params?: UserGetSimpleUsersWithNamesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["userIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/User/GetSimpleUsersWithNames?${stringifiedParams}` : `/api/User/GetSimpleUsersWithNames`
}

export const userGetSimpleUsersWithNames = async (params?: UserGetSimpleUsersWithNamesParams, options?: RequestInit): Promise<SimpleUser[]> => {
  
  return customInstance<SimpleUser[]>(getUserGetSimpleUsersWithNamesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getUserGetSimpleUsersWithNamesQueryKey = (params?: UserGetSimpleUsersWithNamesParams,) => {
    return [
    `/api/User/GetSimpleUsersWithNames`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getUserGetSimpleUsersWithNamesQueryOptions = <TData = Awaited<ReturnType<typeof userGetSimpleUsersWithNames>>, TError = ErrorType<unknown>>(params?: UserGetSimpleUsersWithNamesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetSimpleUsersWithNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetSimpleUsersWithNamesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetSimpleUsersWithNames>>> = ({ signal }) => userGetSimpleUsersWithNames(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userGetSimpleUsersWithNames>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserGetSimpleUsersWithNamesQueryResult = NonNullable<Awaited<ReturnType<typeof userGetSimpleUsersWithNames>>>
export type UserGetSimpleUsersWithNamesQueryError = ErrorType<unknown>


export function useUserGetSimpleUsersWithNames<TData = Awaited<ReturnType<typeof userGetSimpleUsersWithNames>>, TError = ErrorType<unknown>>(
 params: undefined |  UserGetSimpleUsersWithNamesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetSimpleUsersWithNames>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetSimpleUsersWithNames>>,
          TError,
          Awaited<ReturnType<typeof userGetSimpleUsersWithNames>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetSimpleUsersWithNames<TData = Awaited<ReturnType<typeof userGetSimpleUsersWithNames>>, TError = ErrorType<unknown>>(
 params?: UserGetSimpleUsersWithNamesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetSimpleUsersWithNames>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetSimpleUsersWithNames>>,
          TError,
          Awaited<ReturnType<typeof userGetSimpleUsersWithNames>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetSimpleUsersWithNames<TData = Awaited<ReturnType<typeof userGetSimpleUsersWithNames>>, TError = ErrorType<unknown>>(
 params?: UserGetSimpleUsersWithNamesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetSimpleUsersWithNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useUserGetSimpleUsersWithNames<TData = Awaited<ReturnType<typeof userGetSimpleUsersWithNames>>, TError = ErrorType<unknown>>(
 params?: UserGetSimpleUsersWithNamesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetSimpleUsersWithNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserGetSimpleUsersWithNamesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getUserGetSimpleUsersWithNamesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof userGetSimpleUsersWithNames>>, TError = ErrorType<unknown>>(params?: UserGetSimpleUsersWithNamesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetSimpleUsersWithNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetSimpleUsersWithNamesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetSimpleUsersWithNames>>> = ({ signal }) => userGetSimpleUsersWithNames(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetSimpleUsersWithNames>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserGetSimpleUsersWithNamesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof userGetSimpleUsersWithNames>>>
export type UserGetSimpleUsersWithNamesSuspenseQueryError = ErrorType<unknown>


export function useUserGetSimpleUsersWithNamesSuspense<TData = Awaited<ReturnType<typeof userGetSimpleUsersWithNames>>, TError = ErrorType<unknown>>(
 params: undefined |  UserGetSimpleUsersWithNamesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetSimpleUsersWithNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetSimpleUsersWithNamesSuspense<TData = Awaited<ReturnType<typeof userGetSimpleUsersWithNames>>, TError = ErrorType<unknown>>(
 params?: UserGetSimpleUsersWithNamesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetSimpleUsersWithNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetSimpleUsersWithNamesSuspense<TData = Awaited<ReturnType<typeof userGetSimpleUsersWithNames>>, TError = ErrorType<unknown>>(
 params?: UserGetSimpleUsersWithNamesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetSimpleUsersWithNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useUserGetSimpleUsersWithNamesSuspense<TData = Awaited<ReturnType<typeof userGetSimpleUsersWithNames>>, TError = ErrorType<unknown>>(
 params?: UserGetSimpleUsersWithNamesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetSimpleUsersWithNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserGetSimpleUsersWithNamesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getUserGetSimpleUsersUrl = () => {


  

  return `/api/User/GetSimpleUsers`
}

export const userGetSimpleUsers = async ( options?: RequestInit): Promise<SimpleUser[]> => {
  
  return customInstance<SimpleUser[]>(getUserGetSimpleUsersUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getUserGetSimpleUsersQueryKey = () => {
    return [
    `/api/User/GetSimpleUsers`
    ] as const;
    }

    
export const getUserGetSimpleUsersQueryOptions = <TData = Awaited<ReturnType<typeof userGetSimpleUsers>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetSimpleUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetSimpleUsersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetSimpleUsers>>> = ({ signal }) => userGetSimpleUsers({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userGetSimpleUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserGetSimpleUsersQueryResult = NonNullable<Awaited<ReturnType<typeof userGetSimpleUsers>>>
export type UserGetSimpleUsersQueryError = ErrorType<unknown>


export function useUserGetSimpleUsers<TData = Awaited<ReturnType<typeof userGetSimpleUsers>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetSimpleUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetSimpleUsers>>,
          TError,
          Awaited<ReturnType<typeof userGetSimpleUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetSimpleUsers<TData = Awaited<ReturnType<typeof userGetSimpleUsers>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetSimpleUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetSimpleUsers>>,
          TError,
          Awaited<ReturnType<typeof userGetSimpleUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetSimpleUsers<TData = Awaited<ReturnType<typeof userGetSimpleUsers>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetSimpleUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useUserGetSimpleUsers<TData = Awaited<ReturnType<typeof userGetSimpleUsers>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetSimpleUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserGetSimpleUsersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getUserGetSimpleUsersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof userGetSimpleUsers>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetSimpleUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetSimpleUsersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetSimpleUsers>>> = ({ signal }) => userGetSimpleUsers({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetSimpleUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserGetSimpleUsersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof userGetSimpleUsers>>>
export type UserGetSimpleUsersSuspenseQueryError = ErrorType<unknown>


export function useUserGetSimpleUsersSuspense<TData = Awaited<ReturnType<typeof userGetSimpleUsers>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetSimpleUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetSimpleUsersSuspense<TData = Awaited<ReturnType<typeof userGetSimpleUsers>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetSimpleUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetSimpleUsersSuspense<TData = Awaited<ReturnType<typeof userGetSimpleUsers>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetSimpleUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useUserGetSimpleUsersSuspense<TData = Awaited<ReturnType<typeof userGetSimpleUsers>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetSimpleUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserGetSimpleUsersSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getUserUpdateUserUrl = () => {


  

  return `/api/User/UpdateUser`
}

export const userUpdateUser = async (updateUser: UpdateUser, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getUserUpdateUserUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateUser,)
  }
);}




export const getUserUpdateUserMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userUpdateUser>>, TError,{data: BodyType<UpdateUser>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userUpdateUser>>, TError,{data: BodyType<UpdateUser>}, TContext> => {

const mutationKey = ['userUpdateUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userUpdateUser>>, {data: BodyType<UpdateUser>}> = (props) => {
          const {data} = props ?? {};

          return  userUpdateUser(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserUpdateUserMutationResult = NonNullable<Awaited<ReturnType<typeof userUpdateUser>>>
    export type UserUpdateUserMutationBody = BodyType<UpdateUser>
    export type UserUpdateUserMutationError = ErrorType<unknown>

    export const useUserUpdateUser = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userUpdateUser>>, TError,{data: BodyType<UpdateUser>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userUpdateUser>>,
        TError,
        {data: BodyType<UpdateUser>},
        TContext
      > => {

      const mutationOptions = getUserUpdateUserMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getUserGetUserGroupsUrl = (params?: UserGetUserGroupsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/User/GetUserGroups?${stringifiedParams}` : `/api/User/GetUserGroups`
}

export const userGetUserGroups = async (params?: UserGetUserGroupsParams, options?: RequestInit): Promise<SimpleUser[]> => {
  
  return customInstance<SimpleUser[]>(getUserGetUserGroupsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getUserGetUserGroupsQueryKey = (params?: UserGetUserGroupsParams,) => {
    return [
    `/api/User/GetUserGroups`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getUserGetUserGroupsQueryOptions = <TData = Awaited<ReturnType<typeof userGetUserGroups>>, TError = ErrorType<unknown>>(params?: UserGetUserGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetUserGroupsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetUserGroups>>> = ({ signal }) => userGetUserGroups(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userGetUserGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserGetUserGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof userGetUserGroups>>>
export type UserGetUserGroupsQueryError = ErrorType<unknown>


export function useUserGetUserGroups<TData = Awaited<ReturnType<typeof userGetUserGroups>>, TError = ErrorType<unknown>>(
 params: undefined |  UserGetUserGroupsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetUserGroups>>,
          TError,
          Awaited<ReturnType<typeof userGetUserGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetUserGroups<TData = Awaited<ReturnType<typeof userGetUserGroups>>, TError = ErrorType<unknown>>(
 params?: UserGetUserGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetUserGroups>>,
          TError,
          Awaited<ReturnType<typeof userGetUserGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetUserGroups<TData = Awaited<ReturnType<typeof userGetUserGroups>>, TError = ErrorType<unknown>>(
 params?: UserGetUserGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useUserGetUserGroups<TData = Awaited<ReturnType<typeof userGetUserGroups>>, TError = ErrorType<unknown>>(
 params?: UserGetUserGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserGetUserGroupsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getUserGetUserGroupsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof userGetUserGroups>>, TError = ErrorType<unknown>>(params?: UserGetUserGroupsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetUserGroupsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetUserGroups>>> = ({ signal }) => userGetUserGroups(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetUserGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserGetUserGroupsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof userGetUserGroups>>>
export type UserGetUserGroupsSuspenseQueryError = ErrorType<unknown>


export function useUserGetUserGroupsSuspense<TData = Awaited<ReturnType<typeof userGetUserGroups>>, TError = ErrorType<unknown>>(
 params: undefined |  UserGetUserGroupsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetUserGroupsSuspense<TData = Awaited<ReturnType<typeof userGetUserGroups>>, TError = ErrorType<unknown>>(
 params?: UserGetUserGroupsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetUserGroupsSuspense<TData = Awaited<ReturnType<typeof userGetUserGroups>>, TError = ErrorType<unknown>>(
 params?: UserGetUserGroupsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useUserGetUserGroupsSuspense<TData = Awaited<ReturnType<typeof userGetUserGroups>>, TError = ErrorType<unknown>>(
 params?: UserGetUserGroupsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserGetUserGroupsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getUserGetMyLicensesUrl = () => {


  

  return `/api/User/GetMyLicenses`
}

export const userGetMyLicenses = async ( options?: RequestInit): Promise<SimpleLicense[]> => {
  
  return customInstance<SimpleLicense[]>(getUserGetMyLicensesUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getUserGetMyLicensesQueryKey = () => {
    return [
    `/api/User/GetMyLicenses`
    ] as const;
    }

    
export const getUserGetMyLicensesQueryOptions = <TData = Awaited<ReturnType<typeof userGetMyLicenses>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetMyLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetMyLicensesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetMyLicenses>>> = ({ signal }) => userGetMyLicenses({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userGetMyLicenses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserGetMyLicensesQueryResult = NonNullable<Awaited<ReturnType<typeof userGetMyLicenses>>>
export type UserGetMyLicensesQueryError = ErrorType<unknown>


export function useUserGetMyLicenses<TData = Awaited<ReturnType<typeof userGetMyLicenses>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetMyLicenses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetMyLicenses>>,
          TError,
          Awaited<ReturnType<typeof userGetMyLicenses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetMyLicenses<TData = Awaited<ReturnType<typeof userGetMyLicenses>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetMyLicenses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetMyLicenses>>,
          TError,
          Awaited<ReturnType<typeof userGetMyLicenses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetMyLicenses<TData = Awaited<ReturnType<typeof userGetMyLicenses>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetMyLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useUserGetMyLicenses<TData = Awaited<ReturnType<typeof userGetMyLicenses>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetMyLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserGetMyLicensesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getUserGetMyLicensesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof userGetMyLicenses>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetMyLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetMyLicensesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetMyLicenses>>> = ({ signal }) => userGetMyLicenses({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetMyLicenses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserGetMyLicensesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof userGetMyLicenses>>>
export type UserGetMyLicensesSuspenseQueryError = ErrorType<unknown>


export function useUserGetMyLicensesSuspense<TData = Awaited<ReturnType<typeof userGetMyLicenses>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetMyLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetMyLicensesSuspense<TData = Awaited<ReturnType<typeof userGetMyLicenses>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetMyLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetMyLicensesSuspense<TData = Awaited<ReturnType<typeof userGetMyLicenses>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetMyLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useUserGetMyLicensesSuspense<TData = Awaited<ReturnType<typeof userGetMyLicenses>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetMyLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserGetMyLicensesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getUserGetUserLicensesUrl = (params?: UserGetUserLicensesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/User/GetUserLicenses?${stringifiedParams}` : `/api/User/GetUserLicenses`
}

export const userGetUserLicenses = async (params?: UserGetUserLicensesParams, options?: RequestInit): Promise<SimpleLicense[]> => {
  
  return customInstance<SimpleLicense[]>(getUserGetUserLicensesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getUserGetUserLicensesQueryKey = (params?: UserGetUserLicensesParams,) => {
    return [
    `/api/User/GetUserLicenses`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getUserGetUserLicensesQueryOptions = <TData = Awaited<ReturnType<typeof userGetUserLicenses>>, TError = ErrorType<unknown>>(params?: UserGetUserLicensesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetUserLicensesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetUserLicenses>>> = ({ signal }) => userGetUserLicenses(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userGetUserLicenses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserGetUserLicensesQueryResult = NonNullable<Awaited<ReturnType<typeof userGetUserLicenses>>>
export type UserGetUserLicensesQueryError = ErrorType<unknown>


export function useUserGetUserLicenses<TData = Awaited<ReturnType<typeof userGetUserLicenses>>, TError = ErrorType<unknown>>(
 params: undefined |  UserGetUserLicensesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserLicenses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetUserLicenses>>,
          TError,
          Awaited<ReturnType<typeof userGetUserLicenses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetUserLicenses<TData = Awaited<ReturnType<typeof userGetUserLicenses>>, TError = ErrorType<unknown>>(
 params?: UserGetUserLicensesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserLicenses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetUserLicenses>>,
          TError,
          Awaited<ReturnType<typeof userGetUserLicenses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetUserLicenses<TData = Awaited<ReturnType<typeof userGetUserLicenses>>, TError = ErrorType<unknown>>(
 params?: UserGetUserLicensesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useUserGetUserLicenses<TData = Awaited<ReturnType<typeof userGetUserLicenses>>, TError = ErrorType<unknown>>(
 params?: UserGetUserLicensesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetUserLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserGetUserLicensesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getUserGetUserLicensesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof userGetUserLicenses>>, TError = ErrorType<unknown>>(params?: UserGetUserLicensesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetUserLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetUserLicensesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetUserLicenses>>> = ({ signal }) => userGetUserLicenses(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetUserLicenses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserGetUserLicensesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof userGetUserLicenses>>>
export type UserGetUserLicensesSuspenseQueryError = ErrorType<unknown>


export function useUserGetUserLicensesSuspense<TData = Awaited<ReturnType<typeof userGetUserLicenses>>, TError = ErrorType<unknown>>(
 params: undefined |  UserGetUserLicensesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetUserLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetUserLicensesSuspense<TData = Awaited<ReturnType<typeof userGetUserLicenses>>, TError = ErrorType<unknown>>(
 params?: UserGetUserLicensesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetUserLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetUserLicensesSuspense<TData = Awaited<ReturnType<typeof userGetUserLicenses>>, TError = ErrorType<unknown>>(
 params?: UserGetUserLicensesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetUserLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useUserGetUserLicensesSuspense<TData = Awaited<ReturnType<typeof userGetUserLicenses>>, TError = ErrorType<unknown>>(
 params?: UserGetUserLicensesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetUserLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserGetUserLicensesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getUserGetAuthenticatedUserUrl = () => {


  

  return `/api/User/GetAuthenticatedUser`
}

export const userGetAuthenticatedUser = async ( options?: RequestInit): Promise<UserDto> => {
  
  return customInstance<UserDto>(getUserGetAuthenticatedUserUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getUserGetAuthenticatedUserQueryKey = () => {
    return [
    `/api/User/GetAuthenticatedUser`
    ] as const;
    }

    
export const getUserGetAuthenticatedUserQueryOptions = <TData = Awaited<ReturnType<typeof userGetAuthenticatedUser>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetAuthenticatedUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetAuthenticatedUserQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetAuthenticatedUser>>> = ({ signal }) => userGetAuthenticatedUser({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userGetAuthenticatedUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserGetAuthenticatedUserQueryResult = NonNullable<Awaited<ReturnType<typeof userGetAuthenticatedUser>>>
export type UserGetAuthenticatedUserQueryError = ErrorType<unknown>


export function useUserGetAuthenticatedUser<TData = Awaited<ReturnType<typeof userGetAuthenticatedUser>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetAuthenticatedUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetAuthenticatedUser>>,
          TError,
          Awaited<ReturnType<typeof userGetAuthenticatedUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetAuthenticatedUser<TData = Awaited<ReturnType<typeof userGetAuthenticatedUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetAuthenticatedUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetAuthenticatedUser>>,
          TError,
          Awaited<ReturnType<typeof userGetAuthenticatedUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetAuthenticatedUser<TData = Awaited<ReturnType<typeof userGetAuthenticatedUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetAuthenticatedUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useUserGetAuthenticatedUser<TData = Awaited<ReturnType<typeof userGetAuthenticatedUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetAuthenticatedUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserGetAuthenticatedUserQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getUserGetAuthenticatedUserSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof userGetAuthenticatedUser>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetAuthenticatedUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetAuthenticatedUserQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetAuthenticatedUser>>> = ({ signal }) => userGetAuthenticatedUser({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetAuthenticatedUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserGetAuthenticatedUserSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof userGetAuthenticatedUser>>>
export type UserGetAuthenticatedUserSuspenseQueryError = ErrorType<unknown>


export function useUserGetAuthenticatedUserSuspense<TData = Awaited<ReturnType<typeof userGetAuthenticatedUser>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetAuthenticatedUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetAuthenticatedUserSuspense<TData = Awaited<ReturnType<typeof userGetAuthenticatedUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetAuthenticatedUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetAuthenticatedUserSuspense<TData = Awaited<ReturnType<typeof userGetAuthenticatedUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetAuthenticatedUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useUserGetAuthenticatedUserSuspense<TData = Awaited<ReturnType<typeof userGetAuthenticatedUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetAuthenticatedUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserGetAuthenticatedUserSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getUserCreateExternalServiceUserUrl = () => {


  

  return `/api/User/CreateExternalServiceUser`
}

export const userCreateExternalServiceUser = async (createExternalApiUserRequest: CreateExternalApiUserRequest, options?: RequestInit): Promise<CreateExternalApiUserResponse> => {
  
  return customInstance<CreateExternalApiUserResponse>(getUserCreateExternalServiceUserUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createExternalApiUserRequest,)
  }
);}




export const getUserCreateExternalServiceUserMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userCreateExternalServiceUser>>, TError,{data: BodyType<CreateExternalApiUserRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userCreateExternalServiceUser>>, TError,{data: BodyType<CreateExternalApiUserRequest>}, TContext> => {

const mutationKey = ['userCreateExternalServiceUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userCreateExternalServiceUser>>, {data: BodyType<CreateExternalApiUserRequest>}> = (props) => {
          const {data} = props ?? {};

          return  userCreateExternalServiceUser(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserCreateExternalServiceUserMutationResult = NonNullable<Awaited<ReturnType<typeof userCreateExternalServiceUser>>>
    export type UserCreateExternalServiceUserMutationBody = BodyType<CreateExternalApiUserRequest>
    export type UserCreateExternalServiceUserMutationError = ErrorType<unknown>

    export const useUserCreateExternalServiceUser = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userCreateExternalServiceUser>>, TError,{data: BodyType<CreateExternalApiUserRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userCreateExternalServiceUser>>,
        TError,
        {data: BodyType<CreateExternalApiUserRequest>},
        TContext
      > => {

      const mutationOptions = getUserCreateExternalServiceUserMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getUserGetDatabaseRulesUrl = () => {


  

  return `/api/User/GetDatabaseRules`
}

export const userGetDatabaseRules = async ( options?: RequestInit): Promise<string[]> => {
  
  return customInstance<string[]>(getUserGetDatabaseRulesUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getUserGetDatabaseRulesQueryKey = () => {
    return [
    `/api/User/GetDatabaseRules`
    ] as const;
    }

    
export const getUserGetDatabaseRulesQueryOptions = <TData = Awaited<ReturnType<typeof userGetDatabaseRules>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetDatabaseRules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetDatabaseRulesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetDatabaseRules>>> = ({ signal }) => userGetDatabaseRules({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userGetDatabaseRules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserGetDatabaseRulesQueryResult = NonNullable<Awaited<ReturnType<typeof userGetDatabaseRules>>>
export type UserGetDatabaseRulesQueryError = ErrorType<unknown>


export function useUserGetDatabaseRules<TData = Awaited<ReturnType<typeof userGetDatabaseRules>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetDatabaseRules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetDatabaseRules>>,
          TError,
          Awaited<ReturnType<typeof userGetDatabaseRules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetDatabaseRules<TData = Awaited<ReturnType<typeof userGetDatabaseRules>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetDatabaseRules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetDatabaseRules>>,
          TError,
          Awaited<ReturnType<typeof userGetDatabaseRules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetDatabaseRules<TData = Awaited<ReturnType<typeof userGetDatabaseRules>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetDatabaseRules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useUserGetDatabaseRules<TData = Awaited<ReturnType<typeof userGetDatabaseRules>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetDatabaseRules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserGetDatabaseRulesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getUserGetDatabaseRulesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof userGetDatabaseRules>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetDatabaseRules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetDatabaseRulesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetDatabaseRules>>> = ({ signal }) => userGetDatabaseRules({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetDatabaseRules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserGetDatabaseRulesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof userGetDatabaseRules>>>
export type UserGetDatabaseRulesSuspenseQueryError = ErrorType<unknown>


export function useUserGetDatabaseRulesSuspense<TData = Awaited<ReturnType<typeof userGetDatabaseRules>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetDatabaseRules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetDatabaseRulesSuspense<TData = Awaited<ReturnType<typeof userGetDatabaseRules>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetDatabaseRules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserGetDatabaseRulesSuspense<TData = Awaited<ReturnType<typeof userGetDatabaseRules>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetDatabaseRules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useUserGetDatabaseRulesSuspense<TData = Awaited<ReturnType<typeof userGetDatabaseRules>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userGetDatabaseRules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserGetDatabaseRulesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getUserUpdateApiKeyUrl = () => {


  

  return `/api/User/UpdateApiKey`
}

export const userUpdateApiKey = async (updateApiKeyRequest: UpdateApiKeyRequest, options?: RequestInit): Promise<UpdateApiKeyResponse> => {
  
  return customInstance<UpdateApiKeyResponse>(getUserUpdateApiKeyUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateApiKeyRequest,)
  }
);}




export const getUserUpdateApiKeyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userUpdateApiKey>>, TError,{data: BodyType<UpdateApiKeyRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userUpdateApiKey>>, TError,{data: BodyType<UpdateApiKeyRequest>}, TContext> => {

const mutationKey = ['userUpdateApiKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userUpdateApiKey>>, {data: BodyType<UpdateApiKeyRequest>}> = (props) => {
          const {data} = props ?? {};

          return  userUpdateApiKey(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserUpdateApiKeyMutationResult = NonNullable<Awaited<ReturnType<typeof userUpdateApiKey>>>
    export type UserUpdateApiKeyMutationBody = BodyType<UpdateApiKeyRequest>
    export type UserUpdateApiKeyMutationError = ErrorType<unknown>

    export const useUserUpdateApiKey = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userUpdateApiKey>>, TError,{data: BodyType<UpdateApiKeyRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userUpdateApiKey>>,
        TError,
        {data: BodyType<UpdateApiKeyRequest>},
        TContext
      > => {

      const mutationOptions = getUserUpdateApiKeyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getUserAddOrUpdateEmailUrl = () => {


  

  return `/api/User/AddOrUpdateEmail`
}

export const userAddOrUpdateEmail = async (addOrUpdateEmailRequest: AddOrUpdateEmailRequest, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getUserAddOrUpdateEmailUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      addOrUpdateEmailRequest,)
  }
);}




export const getUserAddOrUpdateEmailMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userAddOrUpdateEmail>>, TError,{data: BodyType<AddOrUpdateEmailRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userAddOrUpdateEmail>>, TError,{data: BodyType<AddOrUpdateEmailRequest>}, TContext> => {

const mutationKey = ['userAddOrUpdateEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userAddOrUpdateEmail>>, {data: BodyType<AddOrUpdateEmailRequest>}> = (props) => {
          const {data} = props ?? {};

          return  userAddOrUpdateEmail(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserAddOrUpdateEmailMutationResult = NonNullable<Awaited<ReturnType<typeof userAddOrUpdateEmail>>>
    export type UserAddOrUpdateEmailMutationBody = BodyType<AddOrUpdateEmailRequest>
    export type UserAddOrUpdateEmailMutationError = ErrorType<unknown>

    export const useUserAddOrUpdateEmail = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userAddOrUpdateEmail>>, TError,{data: BodyType<AddOrUpdateEmailRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userAddOrUpdateEmail>>,
        TError,
        {data: BodyType<AddOrUpdateEmailRequest>},
        TContext
      > => {

      const mutationOptions = getUserAddOrUpdateEmailMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    